import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#031f30",
      d: "M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2m11.9 13h-6c-.1-3.6-1-7.2-2.6-10.5 4.8 1.4 8.2 5.5 8.6 10.5m-11-11c1.8 3.4 2.9 7.1 3 11H12c.2-3.8 1.2-7.6 3-11h1.9m-4.3.5C11 7.8 10.2 11.4 10 15H4c.5-5 3.9-9.1 8.6-10.5M4.1 17h6c.1 3.6 1 7.2 2.6 10.5C7.9 26.1 4.5 22 4.1 17m11 11c-1.8-3.4-2.9-7.1-3-11H20c-.2 3.8-1.2 7.6-3 11h-1.9m4.3-.5C21 24.2 21.8 20.6 22 17h6c-.5 5-3.9 9.1-8.6 10.5"
    }, null, -1)
  ]))]))
}
export default { render: render }